var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgPersonalCapacity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.089 4.698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91099 1.35919C7.16612 0.182813 2.85275 0.182813 0.5 1.55525V14.1032C2.85275 12.7308 7.16612 12.7308 9.91099 14.1032C12.6559 12.7308 16.9692 12.7308 19.322 14.1032V1.55525C16.9692 0.182813 12.6559 0.182813 9.91099 1.35919Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91016 1.35889V14.1029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85156 4.88818H7.55706M2.85156 7.63306H7.55706M2.85156 10.3779H5.98856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2656 4.88818H16.9711M12.2656 7.63306H16.9711M12.2656 10.3779H15.4026"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalCapacity);
export default __webpack_public_path__ + "static/media/personal-capacity.4915059adba4a9fa4f00deb6aeb35bd9.svg";
export { ForwardRef as ReactComponent };